import { render } from "./transfereOption.vue?vue&type=template&id=0a2a41d2&scoped=true"
import script from "./transfereOption.vue?vue&type=script&lang=js"
export * from "./transfereOption.vue?vue&type=script&lang=js"

import "./transfereOption.vue?vue&type=style&index=0&id=0a2a41d2&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a2a41d2"]])

export default __exports__